import React, { ReactNode, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { themeCreator } from './base';
import { ThemeModeContext } from '../contexts/ThemeContext';

interface ThemeProviderWrapperProps {
  children: ReactNode;
}

const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = (props) => {
  const { mode } = useContext(ThemeModeContext);
  const theme = themeCreator(mode === 'dark' ? 'dark' : 'cc');

  return (
    <ThemeProvider theme={theme}>
      {props.children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;